/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as PartnerRouteImport } from './routes/partner'
import { Route as CheckoutReturnRouteImport } from './routes/checkout-return'
import { Route as CheckoutRouteImport } from './routes/checkout'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AppRouteImport } from './routes/_app'
import { Route as PartnerIndexRouteImport } from './routes/partner/index'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as PartnerSignupRouteImport } from './routes/partner/signup'
import { Route as PartnerReferralLinkTerminationRouteImport } from './routes/partner/referral-link-termination'
import { Route as PartnerReferralLinkApprovalRouteImport } from './routes/partner/referral-link-approval'
import { Route as AuthSignupRouteImport } from './routes/auth/signup'
import { Route as AuthSigninRouteImport } from './routes/auth/signin'
import { Route as AuthPasswordResetRouteImport } from './routes/auth/password-reset'
import { Route as Auth2faBackupRouteImport } from './routes/auth/2fa-backup'
import { Route as Auth2faRouteImport } from './routes/auth/2fa'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppNewAppRouteImport } from './routes/_app/new-app'
import { Route as AppSupportRouteRouteImport } from './routes/_app/support/route'
import { Route as AppPartnersRouteRouteImport } from './routes/_app/partners/route'
import { Route as AppFinancesRouteRouteImport } from './routes/_app/finances/route'
import { Route as AppDashboardRouteRouteImport } from './routes/_app/dashboard/route'
import { Route as AppSupportIndexRouteImport } from './routes/_app/support/index'
import { Route as AppPartnersIndexRouteImport } from './routes/_app/partners/index'
import { Route as AppFinancesIndexRouteImport } from './routes/_app/finances/index'
import { Route as AppDashboardIndexRouteImport } from './routes/_app/dashboard/index'
import { Route as AppPartnersPartnerIdIndexRouteImport } from './routes/_app/partners/$partnerId/index'
import { Route as AppAppsAppIdIndexRouteImport } from './routes/_app/apps/$appId/index'
import { Route as AppAppsAppIdLinksCreateRouteImport } from './routes/_app/apps/$appId/links/create'
import { Route as AppAppsAppIdLinksLinkIdIndexRouteImport } from './routes/_app/apps/$appId/links/$linkId/index'
import { Route as AppAppsAppIdLinksLinkIdDataRouteImport } from './routes/_app/apps/$appId/links/$linkId/data'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const PartnerRoute = PartnerRouteImport.update({
  id: '/partner',
  path: '/partner',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutReturnRoute = CheckoutReturnRouteImport.update({
  id: '/checkout-return',
  path: '/checkout-return',
  getParentRoute: () => rootRouteImport,
} as any)
const CheckoutRoute = CheckoutRouteImport.update({
  id: '/checkout',
  path: '/checkout',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const PartnerIndexRoute = PartnerIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PartnerRoute,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const PartnerSignupRoute = PartnerSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => PartnerRoute,
} as any)
const PartnerReferralLinkTerminationRoute =
  PartnerReferralLinkTerminationRouteImport.update({
    id: '/referral-link-termination',
    path: '/referral-link-termination',
    getParentRoute: () => PartnerRoute,
  } as any)
const PartnerReferralLinkApprovalRoute =
  PartnerReferralLinkApprovalRouteImport.update({
    id: '/referral-link-approval',
    path: '/referral-link-approval',
    getParentRoute: () => PartnerRoute,
  } as any)
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSigninRoute = AuthSigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPasswordResetRoute = AuthPasswordResetRouteImport.update({
  id: '/password-reset',
  path: '/password-reset',
  getParentRoute: () => AuthRoute,
} as any)
const Auth2faBackupRoute = Auth2faBackupRouteImport.update({
  id: '/2fa-backup',
  path: '/2fa-backup',
  getParentRoute: () => AuthRoute,
} as any)
const Auth2faRoute = Auth2faRouteImport.update({
  id: '/2fa',
  path: '/2fa',
  getParentRoute: () => AuthRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppNewAppRoute = AppNewAppRouteImport.update({
  id: '/new-app',
  path: '/new-app',
  getParentRoute: () => AppRoute,
} as any)
const AppSupportRouteRoute = AppSupportRouteRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => AppRoute,
} as any)
const AppPartnersRouteRoute = AppPartnersRouteRouteImport.update({
  id: '/partners',
  path: '/partners',
  getParentRoute: () => AppRoute,
} as any)
const AppFinancesRouteRoute = AppFinancesRouteRouteImport.update({
  id: '/finances',
  path: '/finances',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRouteRoute = AppDashboardRouteRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppSupportIndexRoute = AppSupportIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSupportRouteRoute,
} as any)
const AppPartnersIndexRoute = AppPartnersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppPartnersRouteRoute,
} as any)
const AppFinancesIndexRoute = AppFinancesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppFinancesRouteRoute,
} as any)
const AppDashboardIndexRoute = AppDashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppDashboardRouteRoute,
} as any)
const AppPartnersPartnerIdIndexRoute =
  AppPartnersPartnerIdIndexRouteImport.update({
    id: '/$partnerId/',
    path: '/$partnerId/',
    getParentRoute: () => AppPartnersRouteRoute,
  } as any)
const AppAppsAppIdIndexRoute = AppAppsAppIdIndexRouteImport.update({
  id: '/apps/$appId/',
  path: '/apps/$appId/',
  getParentRoute: () => AppRoute,
} as any)
const AppAppsAppIdLinksCreateRoute = AppAppsAppIdLinksCreateRouteImport.update({
  id: '/apps/$appId/links/create',
  path: '/apps/$appId/links/create',
  getParentRoute: () => AppRoute,
} as any)
const AppAppsAppIdLinksLinkIdIndexRoute =
  AppAppsAppIdLinksLinkIdIndexRouteImport.update({
    id: '/apps/$appId/links/$linkId/',
    path: '/apps/$appId/links/$linkId/',
    getParentRoute: () => AppRoute,
  } as any)
const AppAppsAppIdLinksLinkIdDataRoute =
  AppAppsAppIdLinksLinkIdDataRouteImport.update({
    id: '/apps/$appId/links/$linkId/data',
    path: '/apps/$appId/links/$linkId/data',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/auth': typeof AuthRouteWithChildren
  '/checkout': typeof CheckoutRoute
  '/checkout-return': typeof CheckoutReturnRoute
  '/partner': typeof PartnerRouteWithChildren
  '/terms': typeof TermsRoute
  '/dashboard': typeof AppDashboardRouteRouteWithChildren
  '/finances': typeof AppFinancesRouteRouteWithChildren
  '/partners': typeof AppPartnersRouteRouteWithChildren
  '/support': typeof AppSupportRouteRouteWithChildren
  '/new-app': typeof AppNewAppRoute
  '/settings': typeof AppSettingsRoute
  '/auth/2fa': typeof Auth2faRoute
  '/auth/2fa-backup': typeof Auth2faBackupRoute
  '/auth/password-reset': typeof AuthPasswordResetRoute
  '/auth/signin': typeof AuthSigninRoute
  '/auth/signup': typeof AuthSignupRoute
  '/partner/referral-link-approval': typeof PartnerReferralLinkApprovalRoute
  '/partner/referral-link-termination': typeof PartnerReferralLinkTerminationRoute
  '/partner/signup': typeof PartnerSignupRoute
  '/partner/': typeof PartnerIndexRoute
  '/dashboard/': typeof AppDashboardIndexRoute
  '/finances/': typeof AppFinancesIndexRoute
  '/partners/': typeof AppPartnersIndexRoute
  '/support/': typeof AppSupportIndexRoute
  '/apps/$appId/': typeof AppAppsAppIdIndexRoute
  '/partners/$partnerId/': typeof AppPartnersPartnerIdIndexRoute
  '/apps/$appId/links/create': typeof AppAppsAppIdLinksCreateRoute
  '/apps/$appId/links/$linkId/data': typeof AppAppsAppIdLinksLinkIdDataRoute
  '/apps/$appId/links/$linkId/': typeof AppAppsAppIdLinksLinkIdIndexRoute
}
export interface FileRoutesByTo {
  '/auth': typeof AuthRouteWithChildren
  '/checkout': typeof CheckoutRoute
  '/checkout-return': typeof CheckoutReturnRoute
  '/terms': typeof TermsRoute
  '/new-app': typeof AppNewAppRoute
  '/settings': typeof AppSettingsRoute
  '/auth/2fa': typeof Auth2faRoute
  '/auth/2fa-backup': typeof Auth2faBackupRoute
  '/auth/password-reset': typeof AuthPasswordResetRoute
  '/auth/signin': typeof AuthSigninRoute
  '/auth/signup': typeof AuthSignupRoute
  '/partner/referral-link-approval': typeof PartnerReferralLinkApprovalRoute
  '/partner/referral-link-termination': typeof PartnerReferralLinkTerminationRoute
  '/partner/signup': typeof PartnerSignupRoute
  '/': typeof AppIndexRoute
  '/partner': typeof PartnerIndexRoute
  '/dashboard': typeof AppDashboardIndexRoute
  '/finances': typeof AppFinancesIndexRoute
  '/partners': typeof AppPartnersIndexRoute
  '/support': typeof AppSupportIndexRoute
  '/apps/$appId': typeof AppAppsAppIdIndexRoute
  '/partners/$partnerId': typeof AppPartnersPartnerIdIndexRoute
  '/apps/$appId/links/create': typeof AppAppsAppIdLinksCreateRoute
  '/apps/$appId/links/$linkId/data': typeof AppAppsAppIdLinksLinkIdDataRoute
  '/apps/$appId/links/$linkId': typeof AppAppsAppIdLinksLinkIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/auth': typeof AuthRouteWithChildren
  '/checkout': typeof CheckoutRoute
  '/checkout-return': typeof CheckoutReturnRoute
  '/partner': typeof PartnerRouteWithChildren
  '/terms': typeof TermsRoute
  '/_app/dashboard': typeof AppDashboardRouteRouteWithChildren
  '/_app/finances': typeof AppFinancesRouteRouteWithChildren
  '/_app/partners': typeof AppPartnersRouteRouteWithChildren
  '/_app/support': typeof AppSupportRouteRouteWithChildren
  '/_app/new-app': typeof AppNewAppRoute
  '/_app/settings': typeof AppSettingsRoute
  '/auth/2fa': typeof Auth2faRoute
  '/auth/2fa-backup': typeof Auth2faBackupRoute
  '/auth/password-reset': typeof AuthPasswordResetRoute
  '/auth/signin': typeof AuthSigninRoute
  '/auth/signup': typeof AuthSignupRoute
  '/partner/referral-link-approval': typeof PartnerReferralLinkApprovalRoute
  '/partner/referral-link-termination': typeof PartnerReferralLinkTerminationRoute
  '/partner/signup': typeof PartnerSignupRoute
  '/_app/': typeof AppIndexRoute
  '/partner/': typeof PartnerIndexRoute
  '/_app/dashboard/': typeof AppDashboardIndexRoute
  '/_app/finances/': typeof AppFinancesIndexRoute
  '/_app/partners/': typeof AppPartnersIndexRoute
  '/_app/support/': typeof AppSupportIndexRoute
  '/_app/apps/$appId/': typeof AppAppsAppIdIndexRoute
  '/_app/partners/$partnerId/': typeof AppPartnersPartnerIdIndexRoute
  '/_app/apps/$appId/links/create': typeof AppAppsAppIdLinksCreateRoute
  '/_app/apps/$appId/links/$linkId/data': typeof AppAppsAppIdLinksLinkIdDataRoute
  '/_app/apps/$appId/links/$linkId/': typeof AppAppsAppIdLinksLinkIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/checkout'
    | '/checkout-return'
    | '/partner'
    | '/terms'
    | '/dashboard'
    | '/finances'
    | '/partners'
    | '/support'
    | '/new-app'
    | '/settings'
    | '/auth/2fa'
    | '/auth/2fa-backup'
    | '/auth/password-reset'
    | '/auth/signin'
    | '/auth/signup'
    | '/partner/referral-link-approval'
    | '/partner/referral-link-termination'
    | '/partner/signup'
    | '/partner/'
    | '/dashboard/'
    | '/finances/'
    | '/partners/'
    | '/support/'
    | '/apps/$appId/'
    | '/partners/$partnerId/'
    | '/apps/$appId/links/create'
    | '/apps/$appId/links/$linkId/data'
    | '/apps/$appId/links/$linkId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/auth'
    | '/checkout'
    | '/checkout-return'
    | '/terms'
    | '/new-app'
    | '/settings'
    | '/auth/2fa'
    | '/auth/2fa-backup'
    | '/auth/password-reset'
    | '/auth/signin'
    | '/auth/signup'
    | '/partner/referral-link-approval'
    | '/partner/referral-link-termination'
    | '/partner/signup'
    | '/'
    | '/partner'
    | '/dashboard'
    | '/finances'
    | '/partners'
    | '/support'
    | '/apps/$appId'
    | '/partners/$partnerId'
    | '/apps/$appId/links/create'
    | '/apps/$appId/links/$linkId/data'
    | '/apps/$appId/links/$linkId'
  id:
    | '__root__'
    | '/_app'
    | '/auth'
    | '/checkout'
    | '/checkout-return'
    | '/partner'
    | '/terms'
    | '/_app/dashboard'
    | '/_app/finances'
    | '/_app/partners'
    | '/_app/support'
    | '/_app/new-app'
    | '/_app/settings'
    | '/auth/2fa'
    | '/auth/2fa-backup'
    | '/auth/password-reset'
    | '/auth/signin'
    | '/auth/signup'
    | '/partner/referral-link-approval'
    | '/partner/referral-link-termination'
    | '/partner/signup'
    | '/_app/'
    | '/partner/'
    | '/_app/dashboard/'
    | '/_app/finances/'
    | '/_app/partners/'
    | '/_app/support/'
    | '/_app/apps/$appId/'
    | '/_app/partners/$partnerId/'
    | '/_app/apps/$appId/links/create'
    | '/_app/apps/$appId/links/$linkId/data'
    | '/_app/apps/$appId/links/$linkId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  CheckoutRoute: typeof CheckoutRoute
  CheckoutReturnRoute: typeof CheckoutReturnRoute
  PartnerRoute: typeof PartnerRouteWithChildren
  TermsRoute: typeof TermsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/partner': {
      id: '/partner'
      path: '/partner'
      fullPath: '/partner'
      preLoaderRoute: typeof PartnerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout-return': {
      id: '/checkout-return'
      path: '/checkout-return'
      fullPath: '/checkout-return'
      preLoaderRoute: typeof CheckoutReturnRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/checkout': {
      id: '/checkout'
      path: '/checkout'
      fullPath: '/checkout'
      preLoaderRoute: typeof CheckoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/partner/': {
      id: '/partner/'
      path: '/'
      fullPath: '/partner/'
      preLoaderRoute: typeof PartnerIndexRouteImport
      parentRoute: typeof PartnerRoute
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/partner/signup': {
      id: '/partner/signup'
      path: '/signup'
      fullPath: '/partner/signup'
      preLoaderRoute: typeof PartnerSignupRouteImport
      parentRoute: typeof PartnerRoute
    }
    '/partner/referral-link-termination': {
      id: '/partner/referral-link-termination'
      path: '/referral-link-termination'
      fullPath: '/partner/referral-link-termination'
      preLoaderRoute: typeof PartnerReferralLinkTerminationRouteImport
      parentRoute: typeof PartnerRoute
    }
    '/partner/referral-link-approval': {
      id: '/partner/referral-link-approval'
      path: '/referral-link-approval'
      fullPath: '/partner/referral-link-approval'
      preLoaderRoute: typeof PartnerReferralLinkApprovalRouteImport
      parentRoute: typeof PartnerRoute
    }
    '/auth/signup': {
      id: '/auth/signup'
      path: '/signup'
      fullPath: '/auth/signup'
      preLoaderRoute: typeof AuthSignupRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/signin': {
      id: '/auth/signin'
      path: '/signin'
      fullPath: '/auth/signin'
      preLoaderRoute: typeof AuthSigninRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/password-reset': {
      id: '/auth/password-reset'
      path: '/password-reset'
      fullPath: '/auth/password-reset'
      preLoaderRoute: typeof AuthPasswordResetRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/2fa-backup': {
      id: '/auth/2fa-backup'
      path: '/2fa-backup'
      fullPath: '/auth/2fa-backup'
      preLoaderRoute: typeof Auth2faBackupRouteImport
      parentRoute: typeof AuthRoute
    }
    '/auth/2fa': {
      id: '/auth/2fa'
      path: '/2fa'
      fullPath: '/auth/2fa'
      preLoaderRoute: typeof Auth2faRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/new-app': {
      id: '/_app/new-app'
      path: '/new-app'
      fullPath: '/new-app'
      preLoaderRoute: typeof AppNewAppRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/support': {
      id: '/_app/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof AppSupportRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/partners': {
      id: '/_app/partners'
      path: '/partners'
      fullPath: '/partners'
      preLoaderRoute: typeof AppPartnersRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/finances': {
      id: '/_app/finances'
      path: '/finances'
      fullPath: '/finances'
      preLoaderRoute: typeof AppFinancesRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/support/': {
      id: '/_app/support/'
      path: '/'
      fullPath: '/support/'
      preLoaderRoute: typeof AppSupportIndexRouteImport
      parentRoute: typeof AppSupportRouteRoute
    }
    '/_app/partners/': {
      id: '/_app/partners/'
      path: '/'
      fullPath: '/partners/'
      preLoaderRoute: typeof AppPartnersIndexRouteImport
      parentRoute: typeof AppPartnersRouteRoute
    }
    '/_app/finances/': {
      id: '/_app/finances/'
      path: '/'
      fullPath: '/finances/'
      preLoaderRoute: typeof AppFinancesIndexRouteImport
      parentRoute: typeof AppFinancesRouteRoute
    }
    '/_app/dashboard/': {
      id: '/_app/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AppDashboardIndexRouteImport
      parentRoute: typeof AppDashboardRouteRoute
    }
    '/_app/partners/$partnerId/': {
      id: '/_app/partners/$partnerId/'
      path: '/$partnerId'
      fullPath: '/partners/$partnerId/'
      preLoaderRoute: typeof AppPartnersPartnerIdIndexRouteImport
      parentRoute: typeof AppPartnersRouteRoute
    }
    '/_app/apps/$appId/': {
      id: '/_app/apps/$appId/'
      path: '/apps/$appId'
      fullPath: '/apps/$appId/'
      preLoaderRoute: typeof AppAppsAppIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/apps/$appId/links/create': {
      id: '/_app/apps/$appId/links/create'
      path: '/apps/$appId/links/create'
      fullPath: '/apps/$appId/links/create'
      preLoaderRoute: typeof AppAppsAppIdLinksCreateRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/apps/$appId/links/$linkId/': {
      id: '/_app/apps/$appId/links/$linkId/'
      path: '/apps/$appId/links/$linkId'
      fullPath: '/apps/$appId/links/$linkId/'
      preLoaderRoute: typeof AppAppsAppIdLinksLinkIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/apps/$appId/links/$linkId/data': {
      id: '/_app/apps/$appId/links/$linkId/data'
      path: '/apps/$appId/links/$linkId/data'
      fullPath: '/apps/$appId/links/$linkId/data'
      preLoaderRoute: typeof AppAppsAppIdLinksLinkIdDataRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppDashboardRouteRouteChildren {
  AppDashboardIndexRoute: typeof AppDashboardIndexRoute
}

const AppDashboardRouteRouteChildren: AppDashboardRouteRouteChildren = {
  AppDashboardIndexRoute: AppDashboardIndexRoute,
}

const AppDashboardRouteRouteWithChildren =
  AppDashboardRouteRoute._addFileChildren(AppDashboardRouteRouteChildren)

interface AppFinancesRouteRouteChildren {
  AppFinancesIndexRoute: typeof AppFinancesIndexRoute
}

const AppFinancesRouteRouteChildren: AppFinancesRouteRouteChildren = {
  AppFinancesIndexRoute: AppFinancesIndexRoute,
}

const AppFinancesRouteRouteWithChildren =
  AppFinancesRouteRoute._addFileChildren(AppFinancesRouteRouteChildren)

interface AppPartnersRouteRouteChildren {
  AppPartnersIndexRoute: typeof AppPartnersIndexRoute
  AppPartnersPartnerIdIndexRoute: typeof AppPartnersPartnerIdIndexRoute
}

const AppPartnersRouteRouteChildren: AppPartnersRouteRouteChildren = {
  AppPartnersIndexRoute: AppPartnersIndexRoute,
  AppPartnersPartnerIdIndexRoute: AppPartnersPartnerIdIndexRoute,
}

const AppPartnersRouteRouteWithChildren =
  AppPartnersRouteRoute._addFileChildren(AppPartnersRouteRouteChildren)

interface AppSupportRouteRouteChildren {
  AppSupportIndexRoute: typeof AppSupportIndexRoute
}

const AppSupportRouteRouteChildren: AppSupportRouteRouteChildren = {
  AppSupportIndexRoute: AppSupportIndexRoute,
}

const AppSupportRouteRouteWithChildren = AppSupportRouteRoute._addFileChildren(
  AppSupportRouteRouteChildren,
)

interface AppRouteChildren {
  AppDashboardRouteRoute: typeof AppDashboardRouteRouteWithChildren
  AppFinancesRouteRoute: typeof AppFinancesRouteRouteWithChildren
  AppPartnersRouteRoute: typeof AppPartnersRouteRouteWithChildren
  AppSupportRouteRoute: typeof AppSupportRouteRouteWithChildren
  AppNewAppRoute: typeof AppNewAppRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppAppsAppIdIndexRoute: typeof AppAppsAppIdIndexRoute
  AppAppsAppIdLinksCreateRoute: typeof AppAppsAppIdLinksCreateRoute
  AppAppsAppIdLinksLinkIdDataRoute: typeof AppAppsAppIdLinksLinkIdDataRoute
  AppAppsAppIdLinksLinkIdIndexRoute: typeof AppAppsAppIdLinksLinkIdIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppDashboardRouteRoute: AppDashboardRouteRouteWithChildren,
  AppFinancesRouteRoute: AppFinancesRouteRouteWithChildren,
  AppPartnersRouteRoute: AppPartnersRouteRouteWithChildren,
  AppSupportRouteRoute: AppSupportRouteRouteWithChildren,
  AppNewAppRoute: AppNewAppRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppIndexRoute: AppIndexRoute,
  AppAppsAppIdIndexRoute: AppAppsAppIdIndexRoute,
  AppAppsAppIdLinksCreateRoute: AppAppsAppIdLinksCreateRoute,
  AppAppsAppIdLinksLinkIdDataRoute: AppAppsAppIdLinksLinkIdDataRoute,
  AppAppsAppIdLinksLinkIdIndexRoute: AppAppsAppIdLinksLinkIdIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  Auth2faRoute: typeof Auth2faRoute
  Auth2faBackupRoute: typeof Auth2faBackupRoute
  AuthPasswordResetRoute: typeof AuthPasswordResetRoute
  AuthSigninRoute: typeof AuthSigninRoute
  AuthSignupRoute: typeof AuthSignupRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  Auth2faRoute: Auth2faRoute,
  Auth2faBackupRoute: Auth2faBackupRoute,
  AuthPasswordResetRoute: AuthPasswordResetRoute,
  AuthSigninRoute: AuthSigninRoute,
  AuthSignupRoute: AuthSignupRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface PartnerRouteChildren {
  PartnerReferralLinkApprovalRoute: typeof PartnerReferralLinkApprovalRoute
  PartnerReferralLinkTerminationRoute: typeof PartnerReferralLinkTerminationRoute
  PartnerSignupRoute: typeof PartnerSignupRoute
  PartnerIndexRoute: typeof PartnerIndexRoute
}

const PartnerRouteChildren: PartnerRouteChildren = {
  PartnerReferralLinkApprovalRoute: PartnerReferralLinkApprovalRoute,
  PartnerReferralLinkTerminationRoute: PartnerReferralLinkTerminationRoute,
  PartnerSignupRoute: PartnerSignupRoute,
  PartnerIndexRoute: PartnerIndexRoute,
}

const PartnerRouteWithChildren =
  PartnerRoute._addFileChildren(PartnerRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  CheckoutRoute: CheckoutRoute,
  CheckoutReturnRoute: CheckoutReturnRoute,
  PartnerRoute: PartnerRouteWithChildren,
  TermsRoute: TermsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
